/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import City from './City/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Zip from './Zip/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/NewRelation/Add/Content/Address"
  
}) {
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral800}
 text="Address"
/>
<div
  data-testid="Address.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
{children}
</React.Fragment>)
}